import {Component, Input, OnInit} from '@angular/core';
import {IRuleInfo} from '../../models/rule-info';
import {IconsEnum} from '../../../../shared-modules/shared-icons/models/icons.enum';

@Component({
  selector: 'app-rule-form',
  templateUrl: './rule-form.component.html',
  styleUrls: ['./rule-form.component.scss'],
  standalone: false,
})
export class RuleFormComponent implements OnInit {

  @Input() rule: IRuleInfo;
  @Input() edits: Record<string, boolean>;
  @Input() og: Record<string, boolean>;
  @Input() requiredRules: Record<string, string[]> = {};
  @Input() invalidRules: Record<string, string[]> = {};
  @Input() check: (edits: Record<string, boolean>, rule: IRuleInfo, invalidRules: Record<string, string[]>,
                   requiredRules: Record<string, string[]>) => void;

  mainClass = 'rule';
  hideChildren = true;

  protected readonly icon = IconsEnum;

  ngOnInit(): void {
    if (this.rule.rules.length > 0) {
      this.mainClass += ' parent-rule';
    }
  }


  // change() {
  //   const control = this.fromGroup.controls[this.rule.humanID];
  //
  //
  //
  //   if (control.value) {
  //     /* check dependencies */
  //     const dependencies: RuleInfo[] = [this.rule];
  //     let invalid = false;
  //
  //     const recursiveStep = (rule: RuleInfo) => {
  //       for (const r of rule.depend) {
  //         if (!dependencies.includes(r)) {
  //           dependencies.push(r);
  //           const c = this.fromGroup.controls[r.humanID];
  //
  //           if (!c.value) {
  //             c.setErrors({
  //               required: {text: `Rule is required by rule "${this.rule.text}"`, humanID: this.rule.humanID}
  //             });
  //             invalid = true;
  //           }
  //           recursiveStep(r);
  //         }
  //       }
  //     };
  //     recursiveStep(this.rule);
  //
  //     if (invalid) {
  //       control.setErrors({depends: 'Dependencies are not met'});
  //     }
  //   } else if (this.rule.rules.length) {
  //     /* Disable children */
  //   }
  // }

  // private checkDependencies(rule: RuleInfo, dependencies: RuleInfo[]) {
  //   const controls = this.fromGroup.controls;
  //   return rule.rules.filter((r) => !controls[r.humanID].value || !controls[r.humanID].valid);
  // }
}
